/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantRole } from './tenantRole';


export interface UserApiModel { 
    id: number;
    username: string;
    email: string;
    displayName: string;
    role: TenantRole;
    tenantId: number;
    tenantName: string;
    isAccountAdmin: boolean;
}
export namespace UserApiModel {
}


